
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { WhereToWatch } from './whereToWatch'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="p" components={components}>{`Le dernier épisode de «Game of Thrones» a été diffusé. Le déroulement de la série, qui a tenu le monde en haleine pendant huit ans, a été l'objet de nombreuses théories. Qui sera le dernier à s'asseoir sur le Trône de fer? Qui va mourir? Lesquelles des nombreuses théories de fans se sont produites? Vous avez pu parier sur l'issue de la série dans notre concours.`}</MDXTag>
<div className='infographic'>
<MDXTag name="h3" components={components}>{`Et voici notre podium de fer:`}</MDXTag>
<div className='ui one inverted statistics'>
  <div className='ui statistic'>
    <div className='value'>
      <img src={require('images/trophy.svg')} />
    </div>
    <div className='label'>Patrick Schenk</div>
  </div>
</div>
<div className='ui one inverted statistics'>
  <div className='ui statistic'>
    <div className='value'>
      <img src={require('images/trophy.svg')} />
    </div>
    <div className='label'>Sebastien Peter</div>
  </div>
</div>
<div className='ui one inverted statistics'>
  <div className='ui statistic'>
    <div className='value'>
      <img src={require('images/trophy.svg')} />
    </div>
    <div className='label'>Alex Crausaz</div>
  </div>
</div>
<MDXTag name="p" components={components}>{`Félicitations! Vous avez gagné 1 an d'abonnement intégral (print et numérique) à choix entre 24 heures, Tribune de Genève et Le Matin Dimanche.`}</MDXTag>
</div>
<div className='ui pointsDescription infographic'>
<div className='titleWrapper'>
<MDXTag name="h3" components={components}>{`Règles du jeu`}</MDXTag>
</div>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Les Spectres et les White Walkers sont considérés comme morts. A moins, bien sûr, qu'ils ne redeviennent humains au cours de l'ultime saison.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Les ressuscités (comme Jon Snow et Beric) sont considérés comme vivants.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Dans les cas peu clairs, notre jury décide.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`S'il y a égalité de points, la personne dont l'estimation à la dernière question est la plus correcte gagne.`}</MDXTag>
</MDXTag>
</div>
           </MDXTag>
  }
}
MDXContent.isMDXComponent = true
  